import type { SidebarMenuItemModel } from '../../types';

import * as Styled from './styles';

export const TooltipMenu = ({
  children,
  label
}: Partial<SidebarMenuItemModel>) => {
  if (!children) {
    return <Styled.Label>{label}</Styled.Label>;
  }

  return (
    <Styled.List>
      {children.map(child => (
        <li key={child.key}>
          <button type='button' onClick={child.onClick}>
            {child.label}
          </button>
        </li>
      ))}
    </Styled.List>
  );
};
